import { gql } from "@apollo/client";

export const DIPLOMA_FIELDS = gql`
  fragment DiplomaFields on Diploma {
    id
    diploma_type
    firstname
    lastname
    personal_number
    date
    author {
      id
      name
      type
    }
    president
    # president {
    #   id
    #   email
    #   firstname
    #   lastname
    #   type
    # }
    principal
    # principal {
    #   id
    #   email
    #   firstname
    #   lastname
    #   type
    # }
    educator {
      id
      name
      title
      status
      certified
      parentGroups {
        id
        name
        title
        logo2 {
          id
          title
          filename
          filesize
          filetype
          url
        }
        parentGroups {
          id
          name
          title
          logo2 {
            id
            title
            filename
            filesize
            filetype
            url
          }
        }
      }
    }
    education
    education_freetext
    credits
    done
    created_at
    updated_at
    uid {
      id
      code
      created_at
    }
  }
`;

export const GET_DIPLOMA = gql`
  query Diploma($id: ID!) {
    certDiploma(id: $id) {
      ...DiplomaFields
    }
  }
  ${DIPLOMA_FIELDS}
`;

export const GET_DIPLOMAS = gql`
  query Diplomas(
    $search: String
    $page: Int
    $limit: Int
    $orderBy: [GetDiplomasOrderByClause]
    $filters: [GetCertFilter]
  ) {
    certDiplomas(
      search: $search
      page: $page
      limit: $limit
      orderBy: $orderBy
      filters: $filters
    ) {
      paginatorInfo {
        total
        currentPage
        hasMorePages
      }
      data {
        ...DiplomaFields
      }
    }
    allGroups(categories: ["educator"]) {
      id
      title
      parentGroups {
        logo3 {
          id
          title
          url
        }
      }
    }
  }
  ${DIPLOMA_FIELDS}
`;
